import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowX: "hidden",
  },
  contentWrapper: {
    margin: 16,
    // marginBottom: 60,
    marginTop: 60,
  },
  btnWrapper: {
    padding: "19px 16px",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    maxWidth: "100%",
    width: 960,
    margin: "0 auto",
  },
  btn: {
    textTransform: "capitalize",
    margin: "10px 0px",
  },
  empty: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    height: "calc(100vh - 186px)",
  },
}));

export default useStyles;
